import dayjs, { Dayjs } from 'dayjs';

import { DATE_FORMAT, TIMESTAMP_FORMAT, TIME_FORMAT } from '@/config/time';

/** Rolling lookback for portal date filters — earliest selectable date is this many months before today. */
export const PORTAL_DATE_LOOKBACK_MONTHS = 6;

export const isInRange = (date: Dayjs, start: Dayjs | null, end: Dayjs | null) =>
  !!(start || end) && (!start || start <= date) && (!end || end >= date);

// PAssert = true - to have an asserted Dayjs value when passing a 100% valid literal
export const parseDate = <PAssert = false>(value: string) => {
  const date = dayjs(value);

  return (date.isValid() ? date : null) as PAssert extends true ? Dayjs : Dayjs | null;
};

export const parseTime = <PAssert = false>(time: string) =>
  parseDate<PAssert>(`2000-01-01T${time}`);

/**
 * Two-line date and time for a table cell.
 * Both lines are the same instant in the browser zone.
 * `includeTimezone` adds the zone name on the time line. Off, the time has no zone label.
 * A blank value has no time line.
 */
export const dateToDoubleDecker = (
  dateStr: string | undefined,
  { includeTimezone = true }: { includeTimezone?: boolean } = {},
) => {
  if (!dateStr) {
    return { title: '' };
  }

  const date = dayjs(dateStr);

  return {
    title: date.format(DATE_FORMAT),
    details: date.format(includeTimezone ? TIME_FORMAT : 'LT'),
  };
};

export const generateTimestamp = () => dayjs().format(TIMESTAMP_FORMAT);
